<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Dialpad Ai Color" class="d-icon d-icon--dialpad-ai-color" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg"><path d="M21.442 7.332a1.916 1.916 0 1 0 0-3.832 1.916 1.916 0 0 0 0 3.832Z" :fill="`url(#${uniqueID}a)`"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.182 6.888c-.434 0-1.182.413-1.57 1.683l-.001.002-3.683 11.873a1.498 1.498 0 0 1-2.86-.888l3.68-11.864V7.69c.6-1.952 2.168-3.798 4.434-3.798 2.265 0 3.831 1.842 4.431 3.79 0 0 0 .001 0 0l2.835 9.142c.39 1.265 1.136 1.68 1.57 1.68a1.926 1.926 0 0 0 1.926-1.927V10.32a1.497 1.497 0 1 1 2.995 0v6.257a4.921 4.921 0 0 1-4.921 4.922c-2.263 0-3.831-1.842-4.431-3.791 0-.001 0 0 0 0l-2.837-9.14c-.389-1.267-1.134-1.68-1.57-1.68Z" :fill="`url(#${uniqueID}b)`"/><defs><linearGradient :id="`${uniqueID}a`" x1="2.799" y1="3.5" x2="17.027" y2="24.562" gradientUnits="userSpaceOnUse"><stop stop-color="#FF5E2F"/><stop offset=".25" stop-color="#FF1356"/><stop offset=".66" stop-color="#FF1BA4"/><stop offset="1" stop-color="#9D42EA"/></linearGradient><linearGradient :id="`${uniqueID}b`" x1="2.799" y1="3.5" x2="17.027" y2="24.562" gradientUnits="userSpaceOnUse"><stop stop-color="#FF5E2F"/><stop offset=".25" stop-color="#FF1356"/><stop offset=".66" stop-color="#FF1BA4"/><stop offset="1" stop-color="#9D42EA"/></linearGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDialpadAiColor',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
